import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchGetSubscription } from "../api";
import iconPay from "../assets/img/icon_pay.svg";

const Payment = () => {
  const { subscription_number } = useParams();
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token || !subscription_number) return;

    fetchGetSubscription(subscription_number, token).then((data) => {
      setSubscription(data[0]);
    });
  }, [subscription_number]);

  if (!subscription) {
    return (
      <section className="section regular-section">
        <h2 className="section-title">
          <i>
            <img src={iconPay} alt="" />
          </i>
          支払い方法
        </h2>
        <p>読み込み中...</p>
      </section>
    );
  }

  return (
    <section className="section regular-section">
      <h2 className="section-title">
        <i>
          <img src={iconPay} alt="" />
        </i>
        支払い方法
      </h2>

      <div className="payment-group group-wrapper">
        <p className="payment-text">{subscription.payment_method_name}</p>
        <div className="payment-link">
          <a
            className="underline"
            href="/contact"
          >
            支払い方法を変更する
          </a>
        </div>
      </div>
    </section>
  );
};

export default Payment;
